import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from '../../hooks/useWindowDimension';
import { TABLET_WIDTH } from '../../constant';
import { Button } from '@chapche/ui';

const CreateNewPreferenceButton = () => {
    const navigate = useNavigate();
    const { width } = useWindowDimensions();
    const { i18n } = useTranslation();

    const createPreferenceButtonName = (width) => {
        return width > TABLET_WIDTH ? i18n.t('app.page.preference.addPreference') : i18n.t('app.page.preference.addPreference').split(' ')[0];
    };

    return (
        <Button variant="outline" className="preference__button"
            onClick={() => navigate('/preference/item/new')}>
            {createPreferenceButtonName(width)}
        </Button>
    );
};

export default CreateNewPreferenceButton;
